import { Link } from "react-router-dom";

export default function Logo({ compact = false }) {
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5">
      <img
  src="/logo.png"
  alt="CA HVAC Direct logo"
  className="h-16 w-auto max-w-[280px] object-contain"
/>
       </Link>
    );
}   
